import { Alert } from '@/components/ui/Alert'
import { Button } from '@/components/ui/Button'
import { Modal } from '@/components/ui/Modal'

const RETROACTIVE_NOTICE =
  '요금을 바꿔도 이미 확정된 예약 금액은 그대로예요. 새로 접수되는 예약부터 적용됩니다.'

/**
 * 요금 저장 확인 모달(설계 §일괄 적용 실행 규약 2).
 *
 * 🚨 **덮어쓰기**라는 사실과 대상 코트 이름을 반드시 보여 준다 — 일괄 적용은 되돌리기 버튼이 없다
 * (원자성이 없어 부분 실패도 가능하다, 설계 R3).
 */
export function CourtPriceSaveConfirmModal({
  axisLabel,
  courtNames,
  isPending,
  onCancel,
  onConfirm,
}: {
  /** 무엇을 저장하는지(예: "평일·주말 요금", "2027-02-06 요금"). */
  axisLabel: string
  /** 현재 코트를 **포함한** 전체 대상. */
  courtNames: string[]
  isPending: boolean
  onCancel: () => void
  onConfirm: () => void
}) {
  return (
    <Modal title="요금 저장" onClose={onCancel}>
      <div className="space-y-4">
        <Alert tone="warning">
          <p>
            코트 {courtNames.length}면의 {axisLabel}이(가) 지금 입력한 값으로 덮어써집니다.
          </p>
          <p className="mt-1">{courtNames.join(', ')}</p>
        </Alert>
        <p className="text-sm text-slateish-600">{RETROACTIVE_NOTICE}</p>

        <div className="flex justify-end gap-2 pt-2">
          <Button type="button" variant="secondary" disabled={isPending} onClick={onCancel}>
            취소
          </Button>
          <Button type="button" disabled={isPending} onClick={onConfirm}>
            {isPending ? '저장하는 중…' : '저장'}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
